import Phaser from "phaser";

export default class PlayerStats extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, scale, lineHeightScale, totalGames, bonezWon, zoomWon, lostGames) {
        super(scene, x, y);
        this.x = x;
        this.y = y;
        this.scale = scale;
        this.lineHeightScale = lineHeightScale;

        //add a bg
        const bg = this.scene.add.graphics();
        bg.fillStyle(0x161b2f, 0.8);
        bg.fillRect(this.x - 50*scale, this.y - 40*scale, 800*scale, 600*scale);
        bg.setDepth(-1);
        bg.setVisible(true);

        this.scene.add.text(this.x, this.y, "Winnings:", { fontSize: 74*scale + "px", fontFamily: "TruculentaBold", fill: '#00F955' });

        this.scene.add.text(this.x, this.y + 110*scale*lineHeightScale, "Total Games:", { fontSize: 74*scale + "px", fontFamily: "TruculentaBold", fill: '#00D1FF' });        
        this.scene.add.text(this.x + 352*scale, this.y + 110*scale*lineHeightScale, totalGames.toLocaleString(), { fontSize: 74*scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF' });

        this.scene.add.image(this.x + 42*scale, this.y + 260*scale*lineHeightScale, 'all_images', 'bone').setScale(0.20 * scale);
        this.scene.add.text(this.x + 112*scale, this.y + 220*scale*lineHeightScale, bonezWon.toLocaleString(), { fontSize: 74*scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF' });

        this.scene.add.image(this.x + 42*scale, this.y + 370*scale*lineHeightScale, 'all_images', "chipz_icon").setScale(0.55 * scale);
        this.scene.add.text(this.x + 112*scale, this.y + 330*scale*lineHeightScale, zoomWon.toLocaleString(), { fontSize: 74*scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF' });

        this.scene.add.text(this.x, this.y + 440*scale*lineHeightScale, "Losses:", { fontSize: 74*scale + "px", fontFamily: "TruculentaBold", fill: '#FF195E' });
        this.scene.add.text(this.x + 216*scale, this.y + 440*scale*lineHeightScale, lostGames.toLocaleString(), { fontSize: 74*scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF' });
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("playerStats", function (x, y, scale, lineHeightScale, totalGames, bonezWon, zoomWon, lostGames) {
    const playerStatsInst = new PlayerStats(this.scene, x, y, scale, lineHeightScale, totalGames, bonezWon, zoomWon, lostGames);

    this.displayList.add(playerStatsInst);
    this.updateList.add(playerStatsInst);

    return playerStatsInst;
})